import { ComposeViewState, SharedFolderComposeViewState } from 'owa-mail-compose-store';
import {
    default as createComposeViewState,
    ComposeViewStateInitProps,
} from './createComposeViewState';

export default async function createSharedFolderComposeViewState(
    props: ComposeViewStateInitProps
): Promise<SharedFolderComposeViewState> {
    const composeViewState: ComposeViewState = await createComposeViewState(props);
    const sharedFolderComposeViewState = composeViewState as SharedFolderComposeViewState;

    sharedFolderComposeViewState.isInSharedFolder = props.isInSharedFolder;
    sharedFolderComposeViewState.folderOwnerEmailAddress = props.folderOwnerEmailAddress;
    sharedFolderComposeViewState.folderPermission = props.folderPermission;

    return sharedFolderComposeViewState;
}
